<ng-container *ngIf="vm$ | async as vm">
  <ng-container *ngIf="status$ | async as status">
    <div
      ngbDropdown
      #ngbDropdown="ngbDropdown"
      [display]="vm.isMobile ? 'dynamic' : 'static'"
      [container]="vm.isMobile ? 'body' : null"
    >
      <button
        #filterToggle
        ngbDropdownToggle
        df-button
        dfButtonType="passive"
        type="button"
        class="collection-filter-btn guts-p-h-1"
        data-dgat="profile-collection-filters-1a6"
        [ngClass]="{
          'collection-filter-btn--selected':
            !!vm.filter.startDate && !!vm.filter.endDate
        }"
      >
        <span
          [ngClass]="{
            'collection-filter-btn--label':
              !vm.filter.startDate && !vm.filter.endDate,
            'collection-filter-btn--selected--label':
              !!vm.filter.startDate && !!vm.filter.endDate
          }"
        >
          {{ i18n.Core_Date }}
          <span
            *ngIf="!!vm.filter.startDate && !!vm.filter.endDate"
            class="color-white"
          >
            {{ vm.filter.startDate | date }} - {{ vm.filter.endDate | date }}
          </span>
        </span>

        <df-icon
          [ngClass]="{
            'collection-filter-btn--icon-':
              !vm.filter.startDate && !vm.filter.endDate,
            'collection-filter-btn--icon--selected':
              !!vm.filter.startDate && !!vm.filter.endDate
          }"
          icon="chevron-down"
          size="small"
          class="guts-p-l-quart guts-m-l-half"
        ></df-icon>
      </button>

      <div ngbDropdownMenu role="menu" class="date-filter-container">
        <fieldset class="guts-m-b-1">
          <div class="grid grid--direction-column">
            <legend class="h4 grid__col-12 guts-m-b-1-half guts-p-b-0">
              {{ i18n.Core_DateAddedToProfile }}
            </legend>
            <form [formGroup]="form" (ngSubmit)="applyDateFilter()">
              <div
                formGroupName="dateRange"
                class="l_flex grid__col-12 guts-m-b-1 guts-p-v-0"
              >
                <div class="field-group">
                  <span
                    class="
                      l_flex
                      m-l_flex
                      guts-p-l-0 guts-m-b-1
                      field-group__input field-group__input--tag
                    "
                  >
                    <df-icon
                      icon="calendar"
                      class="
                        l_flex-center
                        guts-m-r-1
                        color-ebony-a61
                        guts-m-l-half
                      "
                    ></df-icon>
                    <input
                      type="text"
                      ngbDatepicker
                      #startDate="ngbDatepicker"
                      autocomplete="off"
                      [firstDayOfWeek]="7"
                      [minDate]="{ day: 1, month: 1, year: 2000 }"
                      [maxDate]="currentDate | ngbDate"
                      (click)="startDate.toggle()"
                      [placeholder]="'Core_StartDate' | translate"
                      class="guts-p-r-0 date-picker-input"
                      formControlName="startDate"
                      [ngModel]="
                        appliedFilter && appliedFilter.startDate | ngbDate
                      "
                    />
                  </span>
                </div>
                <dgx-validate-field
                  *ngIf="
                    form.get('dateRange.startDate').touched &&
                    form.get('dateRange.startDate').invalid
                  "
                  class="left-text"
                  [message]="'Core_FieldRequired' | translate"
                ></dgx-validate-field>
                <div class="field-group">
                  <span
                    class="
                      l_flex
                      m-l_flex
                      guts-p-l-0
                      field-group__input field-group__input--tag
                    "
                  >
                    <df-icon
                      icon="calendar"
                      class="
                        l_flex-center
                        guts-m-r-1
                        color-ebony-a61
                        guts-m-l-half
                      "
                    ></df-icon>
                    <input
                      type="text"
                      ngbDatepicker
                      #endDate="ngbDatepicker"
                      autocomplete="off"
                      [firstDayOfWeek]="7"
                      [minDate]="{ day: 1, month: 1, year: 2000 }"
                      [maxDate]="currentDate | ngbDate"
                      (click)="endDate.toggle()"
                      [placeholder]="'Core_EndDate' | translate"
                      class="guts-p-r-0 date-picker-input"
                      formControlName="endDate"
                      [ngModel]="
                        appliedFilter && appliedFilter.endDate | ngbDate
                      "
                    />
                  </span>
                </div>
                <dgx-validate-field
                  *ngIf="
                    form.get('dateRange.endDate').touched &&
                    form.get('dateRange.endDate').invalid
                  "
                  class="left-text"
                  [message]="'Core_FieldRequired' | translate"
                ></dgx-validate-field>
                <dgx-validate-field
                  *ngIf="form.get('dateRange').errors?.dateRange"
                  class="left-text"
                  [message]="'AccomplishmentFormCtrl_EndDate' | translate"
                ></dgx-validate-field>
              </div>
              <div class="divider guts-m-b-2"></div>
              <div class="grid__col-12 guts-m-b-1-quart guts-p-v-0">
                <button
                  type="submit"
                  df-button
                  dfButtonType="primary"
                  data-dgat="profile-collection-filters-46f"
                >
                  {{ i18n.Core_ShowResults }}
                </button>
              </div>

              <div class="grid__col-12 guts-p-v-0">
                <button
                  df-button
                  dfButtonType="clear"
                  class="color-blue guts-m-full-1 ib"
                  (click)="resetDates()"
                  [attr.aria-label]="i18n.Core_ResetDateFilters"
                  data-dgat="profileCollection-10e"
                >
                  {{ i18n.Core_Clear }}
                </button>
              </div>
            </form>
          </div>
        </fieldset>
      </div>
    </div>
  </ng-container>
</ng-container>
